var map = {
	"./about.svg": "a85b",
	"./calendar.svg": "0870",
	"./category.svg": "f428",
	"./comment.svg": "03ee",
	"./component.svg": "56d6",
	"./copy.svg": "19b6",
	"./create.svg": "08d2",
	"./dashboard.svg": "f782",
	"./education.svg": "ad1c",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./search.svg": "8e8d",
	"./table.svg": "47f1",
	"./tag.svg": "f1fc",
	"./tree.svg": "93cd",
	"./update.svg": "6f6a",
	"./user.svg": "b3b5",
	"./wx.svg": "ddee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";